/**
 * Get markup for a school's marker popup
 *
 * @param {String} name
 * @param {String} type
 * @param {String} location
 * @param {String} description
 * @param {String} projects
 * @param {String} tags
 * @param {String} url
 * @param {String} mail
 * @returns String
 */

export function getPopupSchool(
    name,
    type,
    location,
    description,
    projects,
    tags,
    url,
    mail
) {
    const typeString = type
        ? `<dd class="lmz-metadata__type">${type}</dd>`
        : '';
    const locationString = location
        ? `<dd class="lmz-metadata__location">${location}</dd>`
        : '';
    const descriptionString = description
        ? `<dd class="lmz-metadata__description">${description}</dd>`
        : '';
    const urlString = url
        ? `<a class="btn btn-outline-dark btn-sm" href="${url}" target="_blank" rel="noopener noreferrer">Webseite</a>`
        : '';
    const mailString = mail
        ? `<a class="btn btn-outline-dark btn-sm" href="mailto:${mail}">E-Mail</a>`
        : '';

    return `
        <dl class="lmz-metadata">
            <dt class="lmz-metadata__name">${name}</dt>
            ${typeString}
            ${locationString}
            ${descriptionString}
            <dd class="lmz-metadata__projects"><b>Beteiligte Projekte:</b> ${projects}</dd>
            <dd class="lmz-metadata__tags"><b>Schlagworte:</b> ${tags}</dd>
            <dd class="lmz-metadata__links">${urlString} ${mailString}</dd>
        </dl>
        `;
}

/**
 * Get markup for a supportsystem marker popup
 *
 * @param {String} name
 * @param {String} type
 * @param {String} location
 * @param {String} description
 * @param {String} url
 * @param {String} mail
 * @returns String
 */

export function getPopupSupport(name, type, location, description, url, mail) {
    const typeString = type
        ? `<dd class="lmz-metadata__type">${type}</dd>`
        : '';
    const locationString = location
        ? `<dd class="lmz-metadata__location">${location}</dd>`
        : '';
    const descriptionString = description
        ? `<dd class="lmz-metadata__description">${description}</dd>`
        : '';
    const urlString = url
        ? `<a class="btn btn-outline-dark btn-sm" href="${url}" target="_blank" rel="noopener noreferrer">Webseite</a>`
        : '';
    const mailString = mail
        ? `<a class="btn btn-outline-dark btn-sm" href="mailto:${mail}">E-Mail</a>`
        : '';

    return `
        <dl class="lmz-metadata">
            <dt class="lmz-metadata__name">${name}</dt>
            ${typeString}
            ${locationString}
            ${descriptionString}
            <dd class="lmz-metadata__links">${urlString} ${mailString}</dd>
        </dl>
        `;
}
